import { render, staticRenderFns } from "./material.vue?vue&type=template&id=57d6e7fc&scoped=true&"
import script from "./material.vue?vue&type=script&lang=ts&"
export * from "./material.vue?vue&type=script&lang=ts&"
import style0 from "./material.vue?vue&type=style&index=0&id=57d6e7fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d6e7fc",
  null
  
)

export default component.exports